import { render, staticRenderFns } from "./CultureExperiencesManage.vue?vue&type=template&id=2b6efff5"
import script from "./CultureExperiencesManage.vue?vue&type=script&lang=js"
export * from "./CultureExperiencesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports